"use strict";
// Copyright (c) Wictor Wilén. All rights reserved.
// Licensed under the MIT license.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_northstar_1 = require("@fluentui/react-northstar");
var microsoftTeams = __importStar(require("@microsoft/teams-js"));
/**
 * Base implementation of the React based interface for the Microsoft Teams app
 */
var TeamsBaseComponent = /** @class */ (function (_super) {
    __extends(TeamsBaseComponent, _super);
    function TeamsBaseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Returns true if hosted in Teams
         * @param timeout timeout in milliseconds, default = 1000
         * @returns a `Promise<boolean>`
         */
        _this.inTeams = function (timeout) {
            if (timeout === void 0) { timeout = 1000; }
            return new Promise(function (resolve, reject) {
                try {
                    microsoftTeams.initialize(function () {
                        resolve(true);
                    });
                    setTimeout(function () {
                        resolve(false);
                    }, timeout);
                }
                catch (e) {
                    reject(e);
                }
            });
        };
        /**
         * Updates the theme
         */
        _this.updateTheme = function (themeStr) {
            var theme;
            switch (themeStr) {
                case "dark":
                    theme = react_northstar_1.themes.teamsDark;
                    break;
                case "contrast":
                    theme = react_northstar_1.themes.teamsHighContrast;
                    break;
                case "default":
                default:
                    theme = react_northstar_1.themes.teams;
            }
            _this.setState({ theme: theme });
        };
        /**
         * Returns the value of a query variable
         */
        _this.getQueryVariable = function (variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var _i = 0, vars_1 = vars; _i < vars_1.length; _i++) {
                var varPairs = vars_1[_i];
                var pair = varPairs.split("=");
                if (decodeURIComponent(pair[0]) === variable) {
                    return decodeURIComponent(pair[1]);
                }
            }
            return undefined;
        };
        return _this;
    }
    /**
     * Static method to render the component
     * @param element DOM element to render the control in
     * @param props Properties
     */
    TeamsBaseComponent.render = function (element, props) {
        return react_dom_1.render(React.createElement(this, props), element);
    };
    return TeamsBaseComponent;
}(React.Component));
exports.default = TeamsBaseComponent;
